import {useWaveCashbackPolling} from '@/common-pages/hooks/use-wave-cashback-polling';

/** 挂载 Wave Cashback 最新未领奖励轮询（无 UI） */
const WaveCashbackPolling = () => {
  useWaveCashbackPolling();
  return null;
};

export default WaveCashbackPolling;
